import { OutputHTMLElement } from "components/output/baseHTMLElementOutput";
import template from "components/output/baseInputOutput.hbs";
import IMask from "imask";
import i18n from "components/i18n/i18n";
import numbro from "numbro";
import sislogUserGlobals from "components/UserGlobals";

export class NumberOutputElement extends OutputHTMLElement {

  private static separators: string;

  private mask: IMask.InputMask<IMask.MaskedNumberOptions>;
  private decimals: number = 0;

  constructor() {
    super();
    NumberOutputElement.separators = NumberOutputElement.separators || i18n.instance.t("locale.separators");

    const decimals = this.getAttribute("decimals");
    if (this.isNumeric(decimals)) {
      this.decimals = parseInt(decimals, 10);
    }

    let className = "c-number-output__input o-form-component__output o-form-component__input-group__input";
    const classCSSOutput = this.getAttribute("classCSSOutput");
    if (classCSSOutput) {
      className += " " + classCSSOutput;
    }

    const optTemplate = {
      "prefixId": "no",
      "id": this.getAttribute("_id"),
      "className": className,
      "style": this.getAttribute("styleCSSOutput"),
      "unit": this.getAttribute("unit"),
      "disableFocusKeyboard": (this.getAttribute("disableFocusKeyboard") === 'true'),
    } as any;
    this.innerHTML = template(optTemplate);

    this.input = this.querySelector("input");
    this.mask = this.initMask();
  }

  private initMask(): IMask.InputMask<IMask.MaskedNumberOptions> {

    const maskOptions = {
      mask: Number,
      scale: this.decimals,
      padFractionalZeros: false, // if true, then pads zeros at end to the length of scale
      normalizeZeros: (this.decimals == 0), // appends or removes zeros at ends
      signed: true, // allow negative
      thousandsSeparator: NumberOutputElement.separators[0],
      radix: NumberOutputElement.separators[1],
    } as any;

    return IMask(this.input, maskOptions);
  }

  public isEqualToInitialValue(value: any): boolean {
    let isEqual: boolean = true;
    const initialValue = this.initialValue.value as number;

    if (value != null) {
      numbro.setLanguage(sislogUserGlobals.language);
      value = numbro.unformat(value);
    }

    isEqual = (initialValue === value);

    return isEqual;
  }

  private doFormat(v: number): string {
    if (v != null) {
      let options = {
        thousandSeparated: NumberOutputElement.separators[0] ? true : false,
        mantissa: this.decimals,
      } as any;

      numbro.setLanguage(sislogUserGlobals.language);
      return numbro(v).format(options);
    }
    return null;
  }

  get data(): number {
    let v = this.input.value;
    if (v === "") {
      return null;
    } else {
      numbro.setLanguage(sislogUserGlobals.language);
      return numbro.unformat(v);
    }
  }

  set data(v: number) {
    this.input.value = this.doFormat(v) ?? null;
    this.initialValue.value = this.data;
    this.mask?.updateValue();
  }

}

export function initNumberOutputWebComponent() {
  window.customElements.define("s6-number-output", NumberOutputElement);
}
